module.exports = __webpack_public_path__ + "img/emoji_cima.646708bf.png";